import axios from "axios";

export function axiosConfig() {
    axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
}

export function axiosAuthorizationToken(AUTH_TOKEN) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
}